module.exports = __webpack_public_path__ + "static/media/BGcolor1.c1da7c9d.png";